import BaseService from './BaseService'
import entities from 'src/config/entities'

class ReferenceThirdPartyService extends BaseService {

  constructor () {
    super({
      path: 'third-parties'
    })
  }

  async getThirdParties ({referenceId, domain}) {
    const data = await this.instance.get(`/references/${domain}/${referenceId}`)
    return {
      data
    }
  }

  updateThirdParty (id, data) {
    return this.instance.put(`${id}/reference`, data)
  }
}

export default new ReferenceThirdPartyService()
